// src/components/SidebarAddControls.jsx
// ============================================================
// MOCK ONLY — koi API call nahi, sirf UI + console.log
// PndMapApp.jsx ke andar import karke use karna hai
// Popup yahan UserManagementPage jaisa hi Dialog component use kar raha hai
// ============================================================
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus, Building2, MapPin, CircleDot } from "lucide-react";

// ────────────────────────────────────────────────────────────
// 1) Add Project — search ke neeche full-width button
// ────────────────────────────────────────────────────────────
export const AddProjectButton = ({ onAdd }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [code, setCode] = useState("");

  const resetForm = () => { setName(""); setCode(""); };
  const handleClose = () => { setOpen(false); setTimeout(resetForm, 200); };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    onAdd?.({ city_name: name.trim(), city_cd: code.trim() || `NEW_${Date.now()}` });
    console.log("new project:", { city_name: name.trim(), city_cd: code.trim() });
    handleClose();
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="w-full mt-2 flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-lg border border-dashed border-primary/40 text-primary text-xs font-semibold hover:bg-primary/10 transition-colors"
      >
        <Plus className="w-3.5 h-3.5" />
        Add Project
      </button>

      <Dialog open={open} onOpenChange={handleClose}>
        <DialogContent className="w-[95vw] max-w-[420px]">
          <DialogHeader>
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/15 text-primary flex-shrink-0">
                <Building2 className="h-4 w-4" />
              </span>
              <div>
                <DialogTitle>Add Project</DialogTitle>
                <DialogDescription>Create a new project / city entry.</DialogDescription>
              </div>
            </div>
          </DialogHeader>
          <form onSubmit={handleSubmit}>
            <div className="grid gap-4 py-4">
              <div className="grid gap-1.5">
                <Label htmlFor="project_name">Project Name <span className="text-destructive">*</span></Label>
                <Input
                  id="project_name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="e.g. Riyadh Downtown"
                  autoComplete="off"
                />
              </div>
              <div className="grid gap-1.5">
                <Label htmlFor="project_code">Project Code</Label>
                <Input
                  id="project_code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  placeholder="e.g. RYD01 (optional)"
                  autoComplete="off"
                />
              </div>
            </div>
            <DialogFooter className="flex-col-reverse sm:flex-row gap-2">
              <Button type="button" variant="outline" onClick={handleClose} className="w-full sm:w-auto">Cancel</Button>
              <Button type="submit" className="w-full sm:w-auto">Add Project</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

// ────────────────────────────────────────────────────────────
// 2) Add Street — project/city row ke corner pe chhota icon
// ────────────────────────────────────────────────────────────
export const AddStreetIcon = ({ city, onAdd }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [code, setCode] = useState("");

  const resetForm = () => { setName(""); setCode(""); };
  const handleClose = () => { setOpen(false); setTimeout(resetForm, 200); };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    const newStreet = { street_name: name.trim(), street_cd: code.trim() || `ST_${Date.now()}`, pnds: [], total_pnds: 0 };
    onAdd?.(city, newStreet);
    console.log("new street:", city, newStreet);
    handleClose();
  };

  return (
    <>
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        title="Add street"
        className="flex-shrink-0 p-1 rounded-md text-muted-foreground hover:text-primary hover:bg-primary/10 transition-colors"
      >
        <Plus className="w-3.5 h-3.5" />
      </button>

      <Dialog open={open} onOpenChange={handleClose}>
        <DialogContent className="w-[95vw] max-w-[420px]">
          <DialogHeader>
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/15 text-primary flex-shrink-0">
                <MapPin className="h-4 w-4" />
              </span>
              <div>
                <DialogTitle>Add Street</DialogTitle>
                <DialogDescription>{city?.city_name ? `Project: ${city.city_name}` : "Add a new street"}</DialogDescription>
              </div>
            </div>
          </DialogHeader>
          <form onSubmit={handleSubmit}>
            <div className="grid gap-4 py-4">
              <div className="grid gap-1.5">
                <Label htmlFor="street_name">Street Name <span className="text-destructive">*</span></Label>
                <Input
                  id="street_name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="e.g. King Fahd Road"
                  autoComplete="off"
                />
              </div>
              <div className="grid gap-1.5">
                <Label htmlFor="street_code">Street Code</Label>
                <Input
                  id="street_code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  placeholder="e.g. KFR01 (optional)"
                  autoComplete="off"
                />
              </div>
            </div>
            <DialogFooter className="flex-col-reverse sm:flex-row gap-2">
              <Button type="button" variant="outline" onClick={handleClose} className="w-full sm:w-auto">Cancel</Button>
              <Button type="submit" className="w-full sm:w-auto">Add Street</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

// ────────────────────────────────────────────────────────────
// 3) Add PND — street row ke corner pe chhota icon
// ────────────────────────────────────────────────────────────
export const AddPndIcon = ({ street, onAdd }) => {
  const [open, setOpen] = useState(false);
  const [pndNumber, setPndNumber] = useState("");
  const [deviceType, setDeviceType] = useState("");

  const resetForm = () => { setPndNumber(""); setDeviceType(""); };
  const handleClose = () => { setOpen(false); setTimeout(resetForm, 200); };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!pndNumber.trim()) return;
    const newPnd = {
      pnd_number: pndNumber.trim(),
      device_type: deviceType.trim() || "BNA",
      latitude: "",
      longitude: "",
    };
    onAdd?.(street, newPnd);
    console.log("new pnd:", street, newPnd);
    handleClose();
  };

  return (
    <>
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        title="Add PND"
        className="flex-shrink-0 p-1 rounded-md text-muted-foreground hover:text-primary hover:bg-primary/10 transition-colors"
      >
        <Plus className="w-3 h-3" />
      </button>

      <Dialog open={open} onOpenChange={handleClose}>
        <DialogContent className="w-[95vw] max-w-[420px]">
          <DialogHeader>
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary/15 text-primary flex-shrink-0">
                <CircleDot className="h-4 w-4" />
              </span>
              <div>
                <DialogTitle>Add PND</DialogTitle>
                <DialogDescription>{street?.street_name ? `Street: ${street.street_name}` : "Add a new PND"}</DialogDescription>
              </div>
            </div>
          </DialogHeader>
          <form onSubmit={handleSubmit}>
            <div className="grid gap-4 py-4">
              <div className="grid gap-1.5">
                <Label htmlFor="pnd_number">PND Number <span className="text-destructive">*</span></Label>
                <Input
                  id="pnd_number"
                  value={pndNumber}
                  onChange={(e) => setPndNumber(e.target.value)}
                  placeholder="e.g. 10234"
                  autoComplete="off"
                />
              </div>
              <div className="grid gap-1.5">
                <Label htmlFor="device_type">Device Type</Label>
                <Input
                  id="device_type"
                  value={deviceType}
                  onChange={(e) => setDeviceType(e.target.value)}
                  placeholder="e.g. BNA / TX"
                  autoComplete="off"
                />
              </div>
            </div>
            <DialogFooter className="flex-col-reverse sm:flex-row gap-2">
              <Button type="button" variant="outline" onClick={handleClose} className="w-full sm:w-auto">Cancel</Button>
              <Button type="submit" className="w-full sm:w-auto">Add PND</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};